import type { Dayjs } from '@vartion/ui'
import { acceptHMRUpdate, defineStore } from 'pinia'

export const useDateOptions = defineStore('dateOptions', () => {
  const counter = ref(0)

  function scheduleNextUpdate() {
    const now = dayjs()
    const tomorrow = now.add(1, 'day').startOf('day')
    const millisecondsUntilTomorrow = tomorrow.diff(now)

    setTimeout(() => {
      counter.value++
      scheduleNextUpdate()
    }, millisecondsUntilTomorrow)
  }

  scheduleNextUpdate()

  const options = computed((): { label: string; value: [Dayjs, Dayjs] }[] => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    counter.value

    return [
      { label: $t('previous-year'), value: [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')] },
      { label: $t('last-count-days', 365), value: [dayjs().subtract(365, 'day').startOf('day'), dayjs().endOf('day')] },
      { label: $t('this-year'), value: [dayjs().startOf('year'), dayjs().endOf('year')] },
      { label: $t('last-count-days', 31), value: [dayjs().subtract(31, 'day').startOf('day'), dayjs().endOf('day')] },
      { label: $t('this-month'), value: [dayjs().startOf('month'), dayjs().endOf('month')] },
      { label: $t('last-count-days', 7), value: [dayjs().subtract(7, 'day').startOf('day'), dayjs().endOf('day')] },
      { label: $t('this-week'), value: [dayjs().startOf('week'), dayjs().endOf('week')] },
      { label: $t('today'), value: [dayjs().startOf('day'), dayjs().endOf('day')] },
    ]
  })

  return {
    options,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDateOptions, import.meta.hot))
}
